import { ChevronDownIcon } from "@chakra-ui/icons";
import { HStack, VStack, Text, Icon, Box, Collapse } from "@chakra-ui/react";

import { useState } from "react";

const CollapsableContent = ({
  icon,
  title,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) => {
  const [showFilters, setShowFilters] = useState(false);
  return (
    <Box
      px={4}
      mt={3}
      py={3}
      bg="#FFFFFF"
      borderRadius="8px"
      border="1px solid rgba(0, 0, 0, 0.10)"
      boxShadow="0px 10px 15px 0px #F7F7F7"
      _hover={{ bg: "rgba(0, 0, 0, 0.03)" }}
    >
      <HStack
        as="button"
        onClick={() => setShowFilters((v) => !v)}
        justify="space-between"
        align="center"
        w="100%"
      >
        <VStack align="flex-start" spacing={0} flex="1">
          <HStack align="center" gap={2}>
            <Box color="rgba(150, 150, 150, 0.70)" mt={1.5}>
              {icon}
            </Box>
            <Text fontSize="18px" fontWeight="500" color="#5D5D5D">
              {title}
            </Text>
          </HStack>
        </VStack>
        <Icon
          as={ChevronDownIcon}
          boxSize={6}
          transition="transform 0.2s"
          transform={showFilters ? "rotate(180deg)" : "rotate(0deg)"}
        />
      </HStack>
      <Collapse
        in={showFilters}
        animateOpacity
        style={{
          overflow: showFilters ? "visible" : "hidden",
        }}
      >
        <Box mt={4}>
          <VStack spacing={3} align="stretch">
            {children}
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default CollapsableContent;